import React, {Component} from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import {Layout} from './hoc/layout';
import Home from './Views/home';
import SearchResults from './Views/SearchResults';
import Yritysnakyma from './Views/company';
import Header from './components/header';
import Footer from './components/footer';
import {IntlProvider} from 'react-intl';
import messages_fi from './static/locales/fi.json';
import messages_sv from './static/locales/sv.json';
import RaksiAlert from './components/Alert';

import 'react-widgets/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './styles/common.css';
import webClient from './api/webClient';
import Newheader from './components/NewHeader';

const messages = {
  fi: messages_fi,
  sv: messages_sv
};

const setFaviconAndMetadata = lvvEnabled => {
  const faviconName = lvvEnabled ? 'faviconlvv.ico' : 'favicon.ico';
  const descriptionText = lvvEnabled
    ? 'Lupa- ja valvontaviraston ylläpitämä rekisteri rahanpesulaissa tarkoitetuista ilmoitusvelvollisista, joita Lupa- ja valvontavirasto valvoo vain rahanpesulain nojalla'
    : 'Aluehallintoviraston ylläpitämä rekisteri rahanpesulaissa tarkoitetuista ilmoitusvelvollisista, joita aluehallintovirasto valvoo vain rahanpesulain nojalla';
  const titleText = lvvEnabled
    ? 'Rahanpesun valvontarekisteri | LVV'
    : 'Rahanpesun valvontarekisteri | Aluehallintovirasto';

  const favicon = document.getElementById('favicon');
  if (favicon) {
    favicon.href = `${process.env.PUBLIC_URL}/${faviconName}`;
  }

  const description = document.getElementById('description');
  if (description) {
    description.content = descriptionText;
  }

  const title = document.getElementById('title');
  if (title) {
    title.textContent = titleText;
  }
};

export default class App extends Component {
  state = {
    language: 'fi',
    languageMessages: messages.fi,
    notification: null,
    featureFlags: undefined
  };

  componentDidMount() {
    webClient.get('/notifications').then(result => {
      this.setState({notification: result.data});
    });
    window.document.documentElement.lang = 'fi-FI';

    webClient.get('/FeatureFlags').then(result => {
      this.setState({featureFlags: result.data});
      setFaviconAndMetadata(result.data.LvvEnabled);
    });

    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = e => {
    if (e.ctrlKey && e.altKey && e.shiftKey && e.key.toLowerCase() === 't') {
      webClient.post('/FeatureFlags').then(result => {
        this.setState({featureFlags: result.data});
        setFaviconAndMetadata(result.data.LvvEnabled);
      });
    }
  };

  hideAlert = () => {
    this.setState(prevState => ({
      notification: null
    }));
  };

  onLanguageChange = newLang => {
    if (newLang === 'fi-FI') {
      this.setState({languageMessages: messages.fi, language: 'fi'});
      window.document.documentElement.lang = newLang;
    } else if (newLang === 'sv-FI') {
      this.setState({languageMessages: messages.sv, language: 'sv'});
      window.document.documentElement.lang = newLang;
    }
  };

  onSearch = (nameorid, businessType, businessFilter, registryType) =>
    this.setState({nameorid, businessType, businessFilter, registryType});

  render() {
    const {featureFlags} = this.state;

    const lvvEnabled = featureFlags ? featureFlags.LvvEnabled : false;

    return (
      <IntlProvider locale={this.state.language} messages={this.state.languageMessages}>
        <BrowserRouter>
          {this.state.notification && (
            <RaksiAlert
              language={this.state.language}
              notification={this.state.notification}
              onClose={this.hideAlert}
            />
          )}

          <div className={lvvEnabled ? 'app-container' : ''}>
            <div className={lvvEnabled ? 'app-content' : 'app_wrapper'}>
              {lvvEnabled ? (
                <Newheader
                  title={document.title}
                  headingLevel="h1"
                  language={this.state.language}
                  onLanguageChange={this.onLanguageChange}
                  lvvEnabled={lvvEnabled}
                />
              ) : (
                <Header
                  title={document.title}
                  headingLevel="h1"
                  language={this.state.language}
                  onLanguageChange={this.onLanguageChange}
                  lvvEnabled={lvvEnabled}
                />
              )}

              <Layout
                language={this.state.language}
                onSearch={this.onSearch}
                lvvEnabled={lvvEnabled}
              >
                <Route
                  path="/"
                  exact
                  render={props =>
                    lvvEnabled ? null : (
                      <Home {...props} lvvEnabled={lvvEnabled} />
                    )
                  }
                />
                <Route
                  path="/yritykset"
                  render={props => (
                    <SearchResults
                      {...props}
                      nameorid={this.state.nameorid}
                      businessFilter={this.state.businessFilter}
                      businessType={this.state.businessType}
                      registryType={this.state.registryType}
                      language={this.state.language}
                      lvvEnabled={lvvEnabled}
                    />
                  )}
                />
              </Layout>
              <Route
                path="/yritykset/:id"
                render={props => <Yritysnakyma {...props} lvvEnabled={lvvEnabled} />}
              />
            </div>
            <Footer lvvEnabled={lvvEnabled} />
          </div>
        </BrowserRouter>
      </IntlProvider>
    );
  }
}
